import angular from 'angular';
import referralDetails from './referralDetails';
import referralModal from './referralModal';

export default angular.module('referral.scenes', [
  referralDetails,
  referralModal,
]).name;
